export default "__VITE_ASSET__6bfb24b1__"